import {
  makeApiProvider,
  useSuspenseApiQuery,
} from '@pflegenavi/shared-frontend/platform';
import { createContext } from 'react';
import type { IOnboardingApi } from './api';
import { OnboardingApi } from './api';
import type {
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type { OnboardingControllerResultTypes } from '@pflegenavi/service-provider-shared/api-endpoints';

const ApiContext = createContext<IOnboardingApi | undefined>(undefined);
const { useApi: useOnboardingApi, ApiProvider: OnboardingApiProvider } =
  makeApiProvider({
    name: 'Onboarding',
    ApiContext,
    newApi: (tenantId, auth, apiUrl) =>
      new OnboardingApi(tenantId, auth, apiUrl),
  });

export { OnboardingApiProvider };

const GET_NURSING_HOME_LIST_KEY = ['get-nursing-home-list'];

export const useGetNursingHomeList = (
  options?: Omit<
    UseSuspenseQueryOptions<
      OnboardingControllerResultTypes['getNursingHomeList'],
      unknown
    >,
    'queryKey' | 'queryFn'
  >
): UseSuspenseQueryResult<
  OnboardingControllerResultTypes['getNursingHomeList'],
  unknown
> => {
  return useSuspenseApiQuery(
    useOnboardingApi,
    GET_NURSING_HOME_LIST_KEY,
    (api) => {
      return api.getNursingHomeList();
    },
    { ...options }
  );
};
